import { render, staticRenderFns } from "./ImagesSliderHotel.vue?vue&type=template&id=4aecb62a&scoped=true&"
import script from "./ImagesSliderHotel.vue?vue&type=script&lang=ts&"
export * from "./ImagesSliderHotel.vue?vue&type=script&lang=ts&"
import style0 from "./ImagesSliderHotel.vue?vue&type=style&index=0&id=4aecb62a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aecb62a",
  null
  
)

export default component.exports